export const STATUS_LABELS = {
  pending: 'En cours',
  confirmed: 'Confirmé',
  rejected: 'Refusé',
};

export const STATUS_VARIANT = {
  pending: 'warning',
  confirmed: 'success',
  rejected: 'danger',
};